import { ColGroupDef } from 'ag-grid-community';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getPromoDurationDays } from 'src/util/grid/cellGetter';

export const commonColDef = {
    cellStyle: { borderRight: '1px solid #dde2eb' },
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: 120
};

export const firstPartyRatesColDefs: ColGroupDef[] = [
    {
        headerName: 'Plan inputs',
        children: [
            {
                headerName: 'Plan',
                field: 'displayName',
                filter: 'agSetColumnFilter',
                ...commonColDef
            },
            {
                headerName: 'PAPER Plan ID',
                field: 'paperPlanName',
                filter: 'agSetColumnFilter',
                ...commonColDef,
                hide: true
            },
            {
                headerName: 'Rate group',
                field: 'rateGroup',
                filter: 'agSetColumnFilter',
                valueFormatter: emptyCellFormatter,
                ...commonColDef
            },
            {
                headerName: 'Plan group',
                field: 'planGroup',
                filter: 'agSetColumnFilter',
                ...commonColDef,
                hide: true
            },
            {
                headerName: 'Plan type',
                field: 'planType',
                filter: 'agSetColumnFilter',
                ...commonColDef,
                hide: true
            },
            {
                headerName: 'Customer pays',
                field: 'customerPays',
                filter: 'agSetColumnFilter',
                ...commonColDef,
                hide: true
            },
            {
                headerName: 'isPromotion',
                field: 'isPromotion',
                filter: 'agSetColumnFilter',
                hide: true
            },
            {
                headerName: 'renewalCadence',
                field: 'renewalCadence',
                filter: 'agSetColumnFilter',
                valueFormatter: emptyCellFormatter,
                ...commonColDef,
                hide: true
            },
            {
                headerName: 'promoDurationInDays',
                field: 'promoDurationInDays',
                filter: 'agSetColumnFilter',
                valueGetter: getPromoDurationDays,
                valueFormatter: emptyCellFormatter,
                ...commonColDef,
                hide: true
            }
        ]
    }
];
